// ======================================================================
// File Name       : DiscriminationDegreeDataSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import RenderField from '../../utils/ReduxFormUtils';
import ReduxFormPaging from '../ReduxFormPaging';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import { VALIDATE_TYPE, MAX_INT } from '../../constants/index';
import CustomButton from '../button/CustomButton';

class DiscriminationDegreeDataSearch extends React.Component {
  render() {
    const {
      courseListData,
      exportCourse,
      collectiveReflection,
      openExportDialog,
      handleSubmit,
      openCollectiveReflectionDialog,
    } = this.props;
    let exportCourseData = '';
    let collectiveReflectionData = '';
    if (exportCourse) {
      exportCourseData = exportCourse;
    }
    if (collectiveReflection) {
      collectiveReflectionData = collectiveReflection;
    }

    return (
      <Col sm={12}>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className='form-horizontal'
        >
          <h3 className="margin-bottom-5">難易度・識別度データを一括取得する場合は、「一括出力」ボタンをクリックしてください</h3>
          <Form.Group className="form-info">
            <Col sm={12} as={Form.Label}>
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                handleClick={openExportDialog}
                text="一括出力"
                iconClass="bi bi-download"
              />
            </Col>
          </Form.Group>
          <h3 className="margin-top-30">指定した「サンプル数の閾値」を超えた学習履歴をもつコンテンツ(問題)の学習要素に対して、</h3>
          <h3 className="margin-top-10">難易度・識別度データの更新を行います</h3>
          <Form.Group className="form-info margin-top-10">
            <Col className="padding-left-clear" as={Form.Label} sm={3}>
            サンプル数の閾値
            </Col>
            <Col sm={5} className="padding-left-clear">
              <RenderField
                type="number"
                name="numberThreshold"
                label="サンプル数の閾値"
                validates={[VALIDATE_TYPE.REQUIRED, VALIDATE_TYPE.MIN_1_MAX_NUMBER]}
                maxNumber={MAX_INT}
                normalizeRadio
              />
            </Col>
            <Col>
              <Button
                variant="primary"
                className="btn-96"
                onClick={handleSubmit(openCollectiveReflectionDialog)}
              >
                一括反映
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default DiscriminationDegreeDataSearch;
